import React, {useEffect} from 'react';
import {Button, Card, Form, Input, message, Radio, Space, Table} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {useBoolean, useInput} from 'react-hanger';
import UseSystem from '../../hooks/apis/useSystem';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import CustomerError from '../../components/CustomerError';
import useAuth from '../../utils/AuthContext';

export default function ManageSystemPage() {
  const schoolNames = useInput();
  const isAllowedRegister = useBoolean(true);
  const auth = useAuth();

  const query = UseSystem.query();
  const saveState = UseSystem.save();

  function refresh() {
    query
      .request()
      .then(res => {
        isAllowedRegister.setValue(res.isAllowedRegister);
        schoolNames.setValue(res.schoolNames.join(','));
      })
      .catch(CommonApiErrorHandler);
  }

  function save() {
    saveState
      .request({
        isAllowedRegister: isAllowedRegister.value,
        schoolNames: schoolNames.value.split(/,|，/),
      })
      .then(refresh)
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    refresh();
  }, []);
  if (!auth.currentUser) return <CustomerError title={'请登录后操作'} />;

  return (
    <div>
      <Card title={'系统配置'}>
        <Form labelCol={{span: 6}} wrapperCol={{span: 14}} layout={'horizontal'}>
          <Form.Item label={'学校名单'} required>
            <TextArea {...schoolNames.eventBind} rows={10} size={'large'} placeholder="请输入学校列表，用逗号隔开" />
          </Form.Item>
          <Form.Item label={'是否开放注册'} required>
            <Radio.Group value={isAllowedRegister.value} onChange={e => isAllowedRegister.setValue(e.target.value)}>
              <Radio value={true}>开放</Radio>
              <Radio value={false}>关闭</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={'-'}>
            <Button onClick={save} loading={saveState.loading}>
              保存
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
